<template>
  <main>
    <vue-headful
      :title="'Enjoj | ' + surrounding.name + ' - webshops'"
      :description="surrounding.description"
      :image="surrounding.banner"
    />
    <ec-page-heading
      :paragraph="paragraph"
      :sub-title="subTitle"
      :title="pageTitle"
      class="intro-text wrapper pt-5 pb-5"
    />
    <ec-webshop-list
      v-loading="isLoading"
      ref="webshopList"
      :current-filter="currentFilter"
      :surroundings="results"
      :total="total"
      id="webshop"
      class="wrapper pt-5 pb-5"
    >
      <div
        slot="top"
        class="view-list__top pb-4 mb-5"
      >
        <ec-filter
          :filters="filters"
          :name="'webshop'"
          :position="'start'"
          @filter="filterItems($event, 'webshopList')"
        />
      </div>
    </ec-webshop-list>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import ecFilter from '@/components/General/Element/Filter'
import ecPageHeading from '@/components/General/PageHeading'
import ecWebshopList from '@/components/Webshop/List'
import IndexView from '@/mixins/IndexView'

export default {
  name: 'ec-webshop-index',
  components: {
    ecFilter,
    ecPageHeading,
    ecWebshopList
  },
  mixins: [IndexView],
  computed: {
    ...mapState([
      'surroundingLoaded'
    ]),
    pageTitle () {
      return 'Shop'
    },
    paragraph () {
      return 'Het aantal online transacties blijft maar toenemen. Met ENJOJ heb je de mogelijkheid om lokaal online te kopen. OP die manier heb je het gemak en de snelheid van online en behouden we samen het lokale in leven.'
    },
    subTitle () {
      return 'Koop veilig en snel lokaal online'
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === null) {
      next(vm => {
        vm.getSiteData()
      })
    } else {
      next(vm => {
        if (vm.surroundingLoaded) {
          vm.setData('webshop')
        }
      })
    }
  },
  watch: {
    surroundingLoaded (condition) {
      if (condition) {
        this.$store.commit('setIsLoading', false)
        this.setData('webshop')
      }
    }
  }
}
</script>
